import { PATH_FALLBACK } from "@/services/PathRewriteService";
import { removeRedundantSlashFromPath } from "./removeRedundantSlashFromPath";

export function createSitePathURL(
  sitePath: string,
  url: string | string[] = "",
) {
  const fixedSitePath = sitePath === PATH_FALLBACK ? "" : sitePath;
  const innerUrl = Array.isArray(url) ? url.filter(Boolean).join("/") : url;

  if (fixedSitePath) {
    const prefix = "/" + fixedSitePath + "/";
    const cleanedInnerUrl = innerUrl.replace(new RegExp(prefix, "i"), "");

    return removeRedundantSlashFromPath(prefix + cleanedInnerUrl + "/");
  }

  return removeRedundantSlashFromPath("/" + innerUrl + "/");
}
